<template>
  <div class="documents-view">
    <div>
      <SidebarToggleView />
      <span class="display-2">Dokumentenablage</span>
    </div>
    <div><span class="subheading">Liste der in SODA erzeugten Dokumente</span></div>
    <div v-if="dates && dates.length > 0">
      <div v-for="date in dates">
        <div class="mt-4">
          <span class="headline">{{ date | moment("dddd, LL") }}</span>
        </div>
        <v-list>
          <template v-for="document in documents[date]">
            <v-list-item>
              <v-list-item-avatar>
                <v-icon color="primary">{{ document.icon }}</v-icon>
              </v-list-item-avatar>
              <v-list-item-content>
                <v-list-item-title>{{ document.type }}</v-list-item-title>
                <v-list-item-subtitle
                  >Erstellt {{ document.tstamp | moment("[am] L [um] LTS [Uhr]") }}</v-list-item-subtitle
                >
              </v-list-item-content>
              <v-list-item-action @click="downloadDocument(document)">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <v-hover>
                      <v-icon v-on="on" slot-scope="{ hover }" :color="`${hover ? 'primary' : 'gray'}`"
                        >save_alt
                      </v-icon>
                    </v-hover>
                  </template>
                  <span>Dokument herunterladen</span>
                </v-tooltip>
              </v-list-item-action>
              <v-list-item-action @click="showDeleteDocumentDialog(document)">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <v-hover>
                      <v-icon v-on="on" slot-scope="{ hover }" :color="`${hover ? 'error' : 'gray'}`">cancel </v-icon>
                    </v-hover>
                  </template>
                  <span>Dokument löschen</span>
                </v-tooltip>
              </v-list-item-action>
            </v-list-item>
          </template>
        </v-list>
      </div>
    </div>
    <div v-else>
      <v-card class="mt-4">
        <v-card-title class="title">
          Hier ist nichts
        </v-card-title>
        <v-card-text>
          <p>
            Um ein <i>Verfahrensverzeichnis</i>, eine <i>TOM-Aufstellung</i> oder eine <i>To-Do-Liste</i> zu erstellen,
            wechseln Sie in die Unternehmens-Sicht und wählen die Funktion <b>Dokumentenerstellung</b>.
          </p>

          <p>Die erzeugten Dokumente finden Sie hier wieder.</p>
        </v-card-text>
      </v-card>
    </div>
    <DocumentDeleteView
      :document="selected_document"
      :prefix="prefix"
      :showThis="show_delete_document_dialog"
      v-on:discard="show_delete_document_dialog = false"
      v-on:didDelete="deleteDocumentCB(document)"
    >
    </DocumentDeleteView>
  </div>
</template>

<script>
import DocumentDeleteView from "./DocumentDeleteView";
import SidebarToggleView from "./SidebarToggleView";

import { util } from "./lib/util";
import moment from "moment";

var groupBy = function(xs, key) {
  return xs.reduce(function(rv, x) {
    (rv[x[key]] = rv[x[key]] || []).push(x);
    return rv;
  }, {});
};

export default {
  name: "ImportView",
  components: {
    DocumentDeleteView,
    SidebarToggleView,
  },
  data: () => ({
    fileName: null,
    documents: null,
    dates: null,
    show_delete_document_dialog: false,
    selected_document: null,
  }),
  mounted() {
    this.listDocuments();
  },
  computed: {
    prefix() {
      return this.$route.params.cid + "/documents/";
    },
  },
  methods: {
    downloadDocument(document) {
      this.getDocument(document.name);
    },
    listDocuments() {
      this.$Amplify.Storage.list(this.prefix, { level: "private" })
        .then((result) => {
          this.documents = [];
          result.forEach((e) =>
            this.documents.push({
              name: e.key.split("/")[e.key.split("/").length - 1],
              tstamp: moment(e.lastModified),
            })
          );
          this.documents.forEach((e) => {
            e.date = e.tstamp.format("YYYYMMDD");
            switch (e.name.split(" ")[0]) {
              case "VerfVz":
                e.type = "Verfahrensverzeichnis";
                e.icon = "picture_as_pdf";
                break;
              case "TOMs":
                e.type = "TOM-Aufstellung";
                e.icon = "picture_as_pdf";
                break;
              case "ToDoListe":
                e.type = "To-Do-Liste";
                e.icon = "assignment_turned_in";
                break;
              case "SODA":
                e.type = "SODA-Datei";
                e.icon = "backup";
                break;
              default:
                e.type = "Diverse";
                e.icon = "error_outline";
            }
          });
          this.documents.sort((a, b) => (a.tstamp < b.tstamp ? 1 : -1));
          this.documents = groupBy(this.documents, "date");
          this.dates = Object.keys(this.documents);
          this.dates.sort((a, b) => (a < b ? 1 : -1));
        })
        .catch((err) => console.error("list err", err));
    },
    getDocument(name) {
      this.$Amplify.Storage.get(this.prefix + name, { level: "private" })
        .then((result) => {
          util.downloadDataUrlFromJavascript(name, result);
        })
        .catch((err) => console.error("get err", err));
    },
    showDeleteDocumentDialog(document) {
      this.selected_document = document;
      this.show_delete_document_dialog = true;
    },
    deleteDocumentCB(document) {
      this.listDocuments();
      this.$eventHub.emit("sync-status-syncing");
      this.$Amplify.Storage.remove(this.prefix + name, { level: "private" })
        .then((result) => {
          this.$eventHub.emit("sync-status-success", {
            entity_type: "Dokument",
            entity_label: name,
            sync_type: "delete",
          });
        })
        .catch((err) => {
          this.$eventHub.emit("sync-status-failure", {
            entity_type: "Dokument",
            entity_label: name,
            sync_type: "delete",
            error: err.errors[0].message,
          });
        });
    },
    onDeleted() {},
    cancel() {
      this.$router.go(-1);
    },
    pickFile() {
      this.$refs.excel.click();
    },
    onFilePicked(e) {
      const files = e.target.files;
      if (files[0] !== undefined) {
        if (files[0].name.lastIndexOf(".") <= 0) {
          return;
        }
        this.fileName = files[0].name;
        const reader = new FileReader();
        reader.readAsArrayBuffer(files[0]);
        reader.onload = (e) => {
          var data = new Uint8Array(e.target.result);
          this.putDocument(this.fileName, data);
          this.fileName = "";
        };
      } else {
        // show alert: "Datei nicht gefunden. Bitte nochmals versuchen."
      }
    },
  },
};
</script>

<style lang="scss" scoped></style>
